import { useNavigate } from 'react-router-dom';
import { usePrototypeRole } from './role';

interface ShellNav {
  /** Props da <Sidebar> do DS. Sem `onToggleCollapse` o DS não renderiza o botão de expandir. */
  sidebarProps: { isCollapsed: boolean; onToggleCollapse?: () => void };
  /** No papel cliente é um no-op: os itens de menu ficam inertes, como em 1466d87. */
  navigate: (to?: string) => void;
}

/**
 * Comportamento do shell (colapso da sidebar + navegação) conforme o papel de acesso.
 * Concentra num lugar o que estava duplicado nos três layouts e nas duas páginas com
 * sidebar própria.
 */
export function useShellNav(): ShellNav {
  const { role, sidebarCollapsed, toggleSidebar } = usePrototypeRole();
  const routerNavigate = useNavigate();

  if (role === 'client') {
    return { sidebarProps: { isCollapsed: true }, navigate: () => {} };
  }

  return {
    sidebarProps: { isCollapsed: sidebarCollapsed, onToggleCollapse: toggleSidebar },
    navigate: (to?: string) => {
      if (to) routerNavigate(to);
    },
  };
}
